"use client";

import {enableStaticRendering} from "mobx-react-lite/es/staticRendering";
import {StoreContext} from "@soprisapps/components/stores/StoreContext";
import {
    PropsWithChildren,
    useMemo,
} from "react";
import {ExecutionEnvironment} from "./InterfaceStore";
import allStoresSingleton, {
    loadStores, rebuildStoresFromInitData,
} from "./StoreLoader";
import {FeatureFlagsContext} from "../utils/featureFlags/FeatureFlagContext";

const ClientTransitionWrapper = (props: PropsWithChildren<{
    initialLookupData: SoprisAppsProps["pageProps"],
}>) => {
    const allStores = useMemo(() => {
        let stores;
        if (ExecutionEnvironment.canUseDOM) {
            stores = allStoresSingleton;
        } else {
            enableStaticRendering(true);
            stores = loadStores(props.initialLookupData);
        }
        for (let key in stores) {
            // initialize all stores
            const store = stores[key];
            if (!store.initialized) {
                store.initialize(props.initialLookupData);
            }
        }

        if (props.initialLookupData.currentFullUrl !== stores.interfaceStore.currentFullUrl) {
            /*
            On a route change, replace all store references with new stores built by merging in new data with old.
            This pattern allows us to update the full UI to keep stores' state consistent across server/client while not
            causing mobx to trigger re-renders during the render lifecycle, which breaks React rules.
             */
            stores = rebuildStoresFromInitData(props.initialLookupData);
        }

        return stores;
    }, [props.initialLookupData.currentFullUrl])

    return <FeatureFlagsContext.Provider value={props.initialLookupData.featureFlags}>
        <StoreContext.Provider value={allStores}>
            {props.children}
        </StoreContext.Provider>
    </FeatureFlagsContext.Provider>
};

export default ClientTransitionWrapper;
